// eslint-disable-next-line import/no-named-as-default
import Icon from "@mdi/react";

import { mdiSetNone } from "@mdi/js";

import { ToolbarButton } from "components/base";

import { useXdaSettingsStore } from "../../context";
import { selectShowOverlap } from "../../context/xdaSettingsSelectors";

function XdaOverlapToggle() {
  const showOverlap = useXdaSettingsStore(selectShowOverlap);
  const updateXdaSettings = useXdaSettingsStore((s) => s.updateXdaSettings);

  const handleToggle = (active: boolean) => {
    updateXdaSettings({ showOverlap: active });
  };

  return (
    <ToolbarButton
      icon={<Icon path={mdiSetNone} size={1.75} />}
      active={showOverlap}
      tooltipText={"Show Overlap"}
      overflowLabel={"Overlap"}
      onToggle={handleToggle}
      styleKey="xdaToolbar"
    />
  );
}

export default XdaOverlapToggle;
